import { UserFollow } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/** Принятие приглашения по одноразовой ссылке (ПОРТ-12…14): публичный экран без навигации. */
export const section = defineSection({
  id: 'org.invitation',
  area: 'public',
  path: 'invite/:token',
  roles: [],
  icon: UserFollow,
  titleKey: 'invite:pageTitle',
  namespaces: ['portal', 'signin'],
  order: 10,
  nav: false,
  load: () => import('./InvitationPage'),
});
